<template>
  <div class="profile-page">
    <div class="box-vip-flex">
      <div class="box-vip" v-for="goods in goodsList" :key="goods.id">
        <div class="topback" v-if="goods.discount">{{ goods.discount }} OFF</div>
        <div class="box-vip-goodsname">{{ goods.name }}</div>
        <div class="box-vip-goodsprice">${{ goods.price }}</div>
        <div class="box-vip-points"><img class="box-vip-points-img" src="@/assets/img/pointsIcon.png" alt="" />&nbsp;{{ goods.points }} credits</div>
        <div class="vip-plan-footer">
          <div>
            <div class="vip-plan-footer-item">
              <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
              <div class="vip-plan-footer-item-desc">Priority processing queue</div>
            </div>
            <div class="vip-plan-footer-item">
              <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
              <div class="vip-plan-footer-item-desc">Unlock all Pro templates</div>
            </div>
            <div class="vip-plan-footer-item">
              <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
              <div class="vip-plan-footer-item-desc">No watermark</div>
            </div>
            <div class="vip-plan-footer-item">
              <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
              <div class="vip-plan-footer-item-desc">No ads.</div>
            </div>
            <div class="vip-plan-footer-item">
              <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
              <div class="vip-plan-footer-item-desc">Pro speed.Multi-task</div>
            </div>
            <div class="vip-plan-footer-item">
              <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
              <div class="vip-plan-footer-item-desc">Cancel anytime</div>
            </div>
          </div>
        </div>
        <div class="vip-plan-footer-btn" :class="basePlanId == goods.planCode ? 'active' : ''" @click="PayClick(goods)">
          <div class="vip-plan-footer-btn-img">Subscribe</div>
        </div>
      </div>
    </div>
    <el-dialog append-to-body custom-class="vip-dialog" :close-on-click-modal="false" :visible.sync="payDialogVisible" width="500px">
      <payTips :isOk="isOk" @okClick="okClickConfirm"></payTips>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from "@/request/modules/login";
import payTips from './payTips.vue';
import {
  getGoodsList,
  queryPlanList,
  createOrder,
  payOrderNotify,
  getAirwallex,
  addPayConsent
} from "@/request/modules/pay.js";
import { GetTypeList } from "@/request/modules/home.js";
export default {
  name: "profile",
  components: {payTips},
  data() {
    return {
      headname: "",
      payTypeYear: true,
      custom_id: "",
      isFangDouDong: true,
      goodsListTemp: [],
      goodsList: [],
      payInfo: {},
      orderInfo: {},
      userInfo: { isVip: false },
      client_id: "",
      basePlanId:"",
      flexpay_success_url: "",
      flexpay_decline_url: "",
      isAirwallex: false,
      isOk: true,
      payDialogVisible:false,
    };
  },
  async mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // this.getBaseUrl();
    this.getUserPayInfo();
    await this.onloadProject();
    if (localStorage.getItem("userInfo")) {
      this.getUserInfo();
    }
  },
  beforeCreate() {},
  mixins: [],
  methods: {
    getUserPayInfo(){
      getAirwallex().then((res) => {
        if (res) {
          if (res.consentStatus == null || res.consentStatus != 1) {
            this.isAirwallex = false;
          }else{
            this.isAirwallex = true;
          }
        }else{
         this.isAirwallex = false;
        }
      }).catch((err) => {
        
      })
    },
    async getBaseUrl() {
      var res = await GetTypeList({
        typeId: 7011,
        p: 1,
        s: 100,
        o: 1,
        c: "sort",
      });
      this.baseUrl = res.rows;
      this.baseUrl.map((item) => {
        if (item.label == "flexpay_success_url") {
          this.flexpay_success_url = item.value;
        }
        if (item.label == "flexpay_decline_url") {
          this.flexpay_decline_url = item.value;
        }
      });
    },
    async getUserInfo() {
      var res = await getUserInfo();
      localStorage.setItem("userInfo", JSON.stringify(res));
      this.userInfo = res;
      if (this.userInfo.name) {
        this.headname = this.userInfo.name.substring(0, 1);
      }
      if (this.userInfo.isVip) {
        this.basePlanId = this.userInfo.basePlanId;
      }
      this.$eventBus.$emit('userInfo-updated', res)
    },
    async onloadProject() {
      var res = await getGoodsList({
        p: 1,
        s: 20,
        type: 1,
      });
      this.goodsListTemp = res.rows;
      if (this.goodsListTemp.length > 0) {
        var res2 = await queryPlanList(this.goodsListTemp[0].id);

        this.goodsList = res2;
        // this.payInfo = this.goodsList.filter(function (item) {
        //   return item.planCode == "vip-yearly";
        // })[0];
      }
    },
    async PayClick(goods) {
      if (this.basePlanId == goods.planCode) {
        return
      }
      this.$confirm('Please confirm subscription', 'Tips', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
       //1、如果没有签约点击订阅的时候 调用创建付款同意书接口
      if (!this.isAirwallex) {
          addPayConsent({
            type: 0,
            planId: goods.id,
            basePlanId: goods.planCode,
            goodsCode: this.goodsListTemp[0].goodsCode,
          }).then((res) => { 
            window.location.href = res.applyUrl;
          }).catch((err) => {
              this.$loading().close();
              this.isOk = false;
              this.payDialogVisible = true;
            });
        }else{
          createOrder({
              channel: 'airwallex',
              basePlanId: goods.planCode,
              goodsCode: this.goodsListTemp[0].goodsCode,
          }).then((res) => { 
            this.$loading().close();
            this.getUserInfo().then(() => {
              this.isOk = true;
              this.payDialogVisible = true;
            });
          }).catch((err) => {
              this.$loading().close();
              this.isOk = false;
              this.payDialogVisible = true;
            });
        }
      })
    },
    okClickConfirm(){
      this.$router.push({ path: `/home`, query: { } });
    },

    handleGoFace(item) {
      console.log("item", item);
      this.$router.push({ path: `/face/templateView`, query: { type: item } });
    },
    handleGoPolicy() {
      const { href } = this.$router.resolve({
        path: "/privacyPolicy",
      });
      window.open(href, "_blank");
    },
    handleGoTerms() {
      const { href } = this.$router.resolve({
        path: "/termsofUse",
      });
      window.open(href, "_blank");
    },
    goodsClick(item) {
      this.payInfo = item;
    },
    timeFormat(dateTime = null, fmt = "yyyy-mm-dd") {
      // 如果为null,则格式化当前时间
      if (!dateTime) dateTime = Number(new Date());
      // 如果dateTime长度为10或者13，则为秒和毫秒的时间戳，如果超过13位，则为其他的时间格式
      if (dateTime.toString().length == 10) dateTime *= 1000;
      let date = new Date(dateTime);
      let ret;
      let opt = {
        "y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "h+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "s+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
  },
};
</script>

<style lang="less" scoped>
.profile-page {
  display: flex;
  flex-direction: column;
  color: #ffffff;
  min-height: 100vh;
}
.profile-header {
  display: flex;
  justify-content: center;
  margin-top: 60px;
  .profile-header-head {
    position: relative;
    .profile-header-head-img {
      background: #bc7935;
      width: 60px;
      height: 60px;
      border-radius: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Microsoft YaHei','PingFang SC';
      font-size: 30px;
      font-weight: 600;
      .vip-headImgUrl {
        border-radius: 50%;
        width: 60px;
        height: 60px;
      }
    }
    .profile-header-head-vip {
      position: absolute;
      bottom: 0;
      right: -16px;
      .vip-logo {
        width: 19px;
        height: 16px;
      }
    }
  }
}
.profile-header-head-name {
  font-family: 'Microsoft YaHei','PingFang SC';
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  margin-top: 20px;
}

.fengexian {
  margin: 5px;
  height: 1px;
  background: linear-gradient(90deg, #00ffff 3%, #8c1af0 102%);
  width: 430px;
}
.vip-desc-box {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  .vip-desc {
    color: #1b1e1d;
    font-family: 'Microsoft YaHei','PingFang SC';
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    font-variation-settings: "opsz" auto;
    width: 419px;
  }
}
.select-plan {
  padding-top: 30px;
  display: flex;
  justify-content: center;
  .select-plan-text {
    width: 430px;
    font-family: 思源黑体;
    font-size: 45px;
    background: linear-gradient(90deg, #00ffff 4%, #8c1af0 102%);
    -webkit-text-fill-color: transparent;
    background-clip: text;
    height: 55px;
  }
}
.vip-plan-box {
  display: flex;
  justify-content: center;
  .vip-plan-box-left {
    display: flex;
    justify-content: space-between;
    width: 430px;
    margin-top: 15px;
    align-items: center;
    .vip-price {
      font-family: 'Microsoft YaHei','PingFang SC';
      font-size: 21px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0em;
    }
  }
  .vip-plan-box-right {
    display: flex;
    width: 430px;
    .vip-save {
      font-family: 'Microsoft YaHei','PingFang SC';
      font-size: 12px;
      font-weight: 600;
      background: #0256ff;
      border-radius: 5px;
      width: 63px;
      height: 30px;
      line-height: 30px;
      padding: 0 2px;
    }
    .vip-old-price {
      color: #767676;
      font-family: 'Microsoft YaHei','PingFang SC';
      font-size: 21px;
      font-weight: 600;
      line-height: 30px;
      height: 30px;
      margin-left: 15px;
      text-decoration: line-through;
      text-decoration-color: #ff0000;
    }
  }
}
.vip-plan-footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  .vip-plan-footer-item {
    display: flex;
    align-items: center;
    width: 250px;
    margin-top: 5px;
    .vip-gou-img {
      width: 14px;
      height: 14px;
    }
    .vip-plan-footer-item-desc {
      font-family: 'Microsoft YaHei','PingFang SC';
      font-size: 16px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      margin-left: 10px;
      color: #111111;
    }
  }
}
.vip-plan-footer-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 34px;
  width: 300px;
  height: 50px;
  background: #4D52DE;
  border-radius: 10px;
  cursor: pointer;
  .vip-plan-footer-btn-img {
    color: #FFFFFF;
  }
}
.vip-plan-footer-btn.active{
  background: #575757;
}
.footer-text {
  margin-bottom: 40px;
  font-family: 'Microsoft YaHei','PingFang SC';
  color: #767676;
  font-size: 12px;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  .footer-text-desc {
    width: 500px;
    .pptext {
      color: #0256ff;
      cursor: pointer;
    }
  }
}
.recharge-main-item {
  position: relative;
  width: 343px;
  height: 60px;
  margin: 10px auto;

  border: 2px solid transparent;
  border-radius: 12px;

  background-image: linear-gradient(0deg, #ffffff 0%, #ffffff 100%),
    linear-gradient(0deg, #272727 0%, #272727 100%);

  background-origin: border-box;
  background-clip: content-box, border-box;
}

.recharge-main-item.active {
  background-image: linear-gradient(0deg, #ffffff 100%, #ffffff 100%),
    linear-gradient(90deg, #00ffff 4%, #8c1af0 102%);
}

.pay-item {
  display: flex;
  align-items: center;
  height: 56px;
}

.item-top {
  margin-left: 20px;

  width: 18px;
  height: 18px;
  border-radius: 1000px;
  opacity: 1;

  box-sizing: border-box;
  border: 2px solid #262626;
}

.item-top.active {
  box-sizing: border-box;
  /* 2主色 */
  border: 5px solid transparent;

  background-image: linear-gradient(0deg, #111 0%, #111 100%),
    linear-gradient(90deg, #00ffff 0%, #8c1af0 102%);

  background-origin: border-box;
  background-clip: content-box, border-box;
}


.item-center {
  margin-left: 18px;
  display: flex;
  justify-content: space-between;
  flex: 1;

  .item-center-left {
    font-size: 16px;
    color: #000000;
    flex: 1;
    font-family: 'Microsoft YaHei','PingFang SC';
  }

  .item-bottom {
    margin-right: 32px;
    font-size: 16px;
    color: #000000;
    font-family: 'Microsoft YaHei','PingFang SC';
  }
}
.box-vip-flex{
  display: flex;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap; /* 允许换行 */
  gap: 40px; /* 卡片之间的间距 */
  .box-vip {
    font-family: 'Microsoft YaHei','PingFang SC';
    margin-top: 40px;
    border-radius: 15px;
    background: #ffffff;
    // margin: 30px auto;
    width: 368px;
    text-align: center;
    position: relative;
    .box-vip-goodsname{
      font-size: 24px;
      font-weight: 600;
      color: #0A0A0A;
      margin-top: 20px;
    }
    .box-vip-goodsprice{
      font-size: 56px;
      font-weight: 600;
      color: #04794D;
      margin-top: 10px;
    }
    .topback {
      position: absolute;
      width: 96px;
      height: 21px;
      border-radius: 0px 15px 0px 24px;
      right: 0;
      top: 0;

      font-size: 12px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0em;
      color: #000000;
      background: linear-gradient(270deg, #1bbfec 0%, #21d0c2 100%);
      background-repeat: no-repeat;
      background-size: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Microsoft YaHei','PingFang SC';
    }
    .box-vip-points{
      margin-top: 20px;
      font-size: 24px;
      font-weight: 600;
      color: #0A0A0A;
      display: flex;
      justify-content: center;
      align-items: center;
      .box-vip-points-img{
        width: 23.4px;
        height: 24.9px;
      }
    }
  }
  
}
.homepage-footer-text2{
    font-family: 'Microsoft YaHei','PingFang SC';
    font-size: 16px;
    line-height: normal;
    color: #FFFFFF;
    padding: 20px 0;
    text-align: center;
  }
  :deep .vip-dialog{
  border-radius: 30px;
  }
</style>
